<template>
  <div class="schema">
  <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "What is the Income Marketplace and why invest with us?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Income Marketplace at getincome.com connects investors and borrowers in a safe and transparent environment. On the marketplace you can invest in loans issued by loan originators globally. Both retail and institutional investors can invest in small fractions of the listed loans and earn competitive yields."
        }
      },
        {
          "@type": "Question",
          "name": "How is Income Marketplace different from other marketplaces?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Our founders know what it feels like to have money at risk in peer-to-peer investments. Income Marketplace started from the idea of improving investor security in peer-to-peer and we have created safeguards to guard your hard-earned capital in case a borrower or loan originator could not fulfil its obligations towards you. (Read more on \"Security\" page)"
          }
        },
        {
          "@type": "Question",
          "name": "Are there any fees for investors?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Investing on Income Marketplace is free for you. We earn on the fees we charge the loan originators when their loans get invested in by investors."
          }
        },
        {
          "@type": "Question",
          "name": "What are the typical returns on Income Marketplace?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Income is not the marketplace for the highest peer-to-peer yield. We value sustainability and increased security. We require more security from loan originators (LO) than other marketplaces. This limits their leverage for the benefit of our marketplace investors. Very high interest offers are often also very risky. A normal funding cost in the market (how much prime LOs pay for the money from investors) is between 7-15%. We know this level is sustainable with the terms we offer them and that an investor return in that range can be solid and long term."
          }
        },
        {
          "@type": "Question",
          "name": "Who can invest?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The marketplace is open to both individuals and companies. To register as an investor, you have to: Have a bank account in one of the countries of the European Economic Area (European Union, Norway, Iceland, UK, Switzerland  and Liechtenstein);EEA country issued passport, ID card, or residence permit;Be at least 18 years old;Provide a copy of your identification documents to Income Company.Family trusts, partnerships, limited liability companies, and other organizations must have a bank account and be registered in the European Economic Area (European Union, Norway, Iceland, UK, Switzerland and Liechtenstein). The individual registering the company must have the legal right to represent the company."
          }
        },
        {
          "@type": "Question",
          "name": "How do I start investing?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Create an account with your email address Verify your identity in a few easy steps Deposit funds to your Income account Start investing by manually choosing loans or using auto invest. If anything is unclear we will be happy to help you."
          }
        },
        {
          "@type": "Question",
           "name": "Why is identification needed?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "In order to comply with European laws and regulations, we are asking you to go through the verification process. We are committed to providing a safe marketplace, so you providing your information helps us to comply with regulations and to protect your money and account."
          }
        },
        {
          "@type": "Question",
           "name": "How is identification done and what is Veriff?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "To make sure it’s really you creating an account, we are asking you to use Veriff to verify your identity. Veriff is a global, full-service identity verification solution that is compliant with GDPR, CCPA, SOC2 type II, and WCAG Accessibility Guidelines. Your privacy and data are protected. Before you start the verification process, please ensure you have a stable Internet connection and you have your identification document ready. Your ID shouldn’t be expired or damaged in any way. We currently accept the following documents: Passport,National identification card. Please note that we don’t accept driving licences or residence permits as identification documents. To verify your account, click on Get verified button in the Identity section and then follow the instructions."
          }
        },
        {
          "@type": "Question",
           "name": "I’m having problems with verification, what can I do?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Don’t worry, we’ve got you covered! If you are experiencing any difficulties with getting your account verified, please read the following tips on how to avoid possible mistakes and contact our Support team at hello@getincome.com!"
          }
        },
        {
          "@type": "Question",
           "name": "How can I deposit funds?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can find the deposit details in your account under \"Deposit/Withdraw\". The minimum first deposit is 10€ and must be transferred from an investor’s personal bank account operating within the European Economic Area. We only accept payments in euros; please make sure you have selected the euro currency before you make the transfer. Your deposit will be processed as soon as it is received. Please note that it may take up to two business days."
          }
        },
        {
          "@type": "Question",
           "name": "How can I withdraw funds?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can withdraw funds from your account by choosing \"Deposit/Withdraw\" from the menu and following the instructions. Your withdrawal will be processed as soon as you enter it. Please note that the actual payment transfer may take up to two business days. We only send funds to the account you made the deposit from."
          }
        },
        {
          "@type": "Question",
           "name": "What is the minimum amount that can be invested?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The minimum investment in any single loan on the primary market is €10. There is no minimum for investments in the secondary market when it opens."
          }
        },
        {
          "@type": "Question",
           "name": "How do I earn passive income from my investments?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Each borrower makes monthly payments according to their loan agreements, which can consist of principal, interest and late payment fees, or any combination of the above. Your share of the payment, which is calculated based on your investment in any particular loan, will be added to your Income account after the payment has been processed. You can then choose to invest the funds in more loans or withdraw them to your IBAN bank account."
          }
        },
        {
          "@type": "Question",
           "name": "How is Income Marketplace different from the other marketplaces?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We are focused on investor security. Before we onboard a loan originator (LO) and allow them to place loans on the marketplace, we investigate their loan book and loan origination quality. Based on our findings we set a \"safety margin\" or \"junior share\" at a level where we believe investors are safe even if the LO should default on its obligations. The \"safety margin\" means that if the LO defaults, all the junior share of LOs and their revenue items (Interests and fees) will first be used to pay investors’ principal and interest, and only once all investor funds have been recovered is the remaining cash paid to the LO. For example, if there are 1000 loans by LO funded on the marketplace and 800 of them will perform perfectly, all LO junior share and all excess earnings from those 800 loans will benefit the 200 non-performing loans in case of LO default."
          }
        },
        { "@type": "Question",
          "name": "What different options do I have when investing into loans?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "To invest, you must have available funds on your Income Marketplace account. You can choose to invest either manually, or by using the auto invest function: Manual Investment: You can manually browse, filter and invest into listed loans. By investing manually, you can compare the details of each loan such as term, interest rate, loan purpose and borrower information. Rather than funding an entire loan, investors can purchase a piece of a certain loan. Auto invest: Automated investments are performed by an auto invest tool. To start using auto invest you must create an auto invest portfolio (strategy). This is done by setting what type of loans you would like to invest in continuously (term and type of the loan, country of issuance, loan originator, etc.). The system will then automatically invest in loans that match your criteria. When you have set a maximum euro amount for your auto invest portfolio, the tool will re-invest loan repayments to loans matching your set criteria and ensure that all your capital is earning interest and is efficiently deployed."
          }
        },
        { "@type": "Question",
          "name": "How is the interest calculated?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Interest is calculated on a daily basis on the outstanding balance of your made investments. The formula for calculating interest is as follows: Invested amount * Amount of days * Interest rate/365 "
          }
        },
        { "@type": "Question",
          "name": "What is the secondary market and how does it work?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Secondary market coming soon. "
          }
        },
        { "@type": "Question",
          "name": "What is auto invest and how does it work?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Auto invest is an advanced feature that allows investors to create an investment portfolio based on custom sets of criteria (loan term, type, interest, investment amount, loan originator and country). After setting up auto invest, the system will automatically filter and invest in loans meeting the requirements. Auto invest allows investors to save time and ensures efficient allocation of funds. "
          }
        },
        { "@type": "Question",
          "name": "What if I want to exit an investment in a loan before it reaches maturity?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You will need to wait for the loans to reach maturity. We are working on a secondary market function to increase liquidity of investments. "
          }
        },
        { "@type": "Question",
          "name": "How are my earnings taxed?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Income from investments is usually taxed as capital gains, based on your country of residence. The investor is responsible for declaring their income and if you are not sure how this is done we recommend you to consult with your local authorities or advisers. Investors can download their account statement for tax purposes from their investor account at any time."
          }
        },
        { "@type": "Question",
          "name": "Where can I learn more about how to invest on Income Marketplace?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "In addition to our website, you can learn more about us from our training videos on YouTube and our social media accounts. "
          }
        },
        { "@type": "Question",
          "name": "How does Income Marketplace prioritize the safety of investments on its platform?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We recommend you read the \"Security\" part of our website."
          }
        },
        { "@type": "Question",
          "name": "What happens if a borrower defaults on their payments?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "In the event that a borrower does not make a payment according to schedule, the loan originator is obligated to buy back the loan from you once it has become 60 days overdue. This function called a \"buyback obligation\" and covers principal and all accrued interest."
          }
        },
        { "@type": "Question",
          "name": "What happens if a loan originator cannot honor its buyback obligation or other obligations.",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "In the event that a loan originator (LO) cannot service its obligations (this event is called a \"default\") the LO ́s \"junior share\" as well as profits from its performing loans placed on the Income Marketplace will act as security for investors. The borrower payments to all of these loans will be collected by Income and used to service the loans until all investor claims have been satisfied."
          }
        },
        { "@type": "Question",
          "name": "What happens if Income Company goes out of business?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "In the unlikely event that Income Company would go out of business the appointed insolvency administrator shall take over the settlement of all outstanding investments."
          }
        },
        { "@type": "Question",
          "name": "How are Investors' funds separated from the funds of Income marketplace?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Investors' funds are held on a separate bank account from daily activity accounts in the bank."
          }
        },
        { "@type": "Question",
          "name": "What is a loan originator?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Loan originators (LO) are financial companies offering credit services. Further information about each LO on Income Marketplace can be found on the \"Loan Originators\" part of our website (coming soon)."
          }
        },
        { "@type": "Question",
          "name": "For what purposes are loans issued to borrowers?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Loans can be issued to borrowers for different purposes, including business needs, home improvement, vehicle purchase, other major purchases, and many other reasons. The purpose of the loan is noted under each listing and is dependent on the borrower and loan originator. "
          }
        },
        { "@type": "Question",
          "name": "Can I know who the borrower is?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Investors are able to see a certain amount of information about borrowers on our marketplace, including how much they have borrowed and for what purpose. For security reasons and to comply with data protection laws, we do not reveal the full names or addresses of borrowers. "
          }
        },
        { "@type": "Question",
          "name": "Where can I learn more about the loan originators on Income Marketplace?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Please refer to our \"Loan Originators\" page where we include more detailed information about the loan originators currently on our marketplace. "
          }
        }
      ]
    }
  </script>
  </div>
</template>

<script>
export default {
  name: 'Help-Schema'
}
</script>
